export default __webpack_public_path__ + "static/media/image-black-cropped.6ed89b7d.jpg";